export default __webpack_public_path__ + "media/images/icons/edit-regular-3c9aad14d3d21daa587b5b2690065e36.svg";